module.exports = __webpack_public_path__ + "static/media/ine.c72a0b19.png";